/* Bisou Studio – script du thème. Chaque bloc gère une fonction de la boutique. */
(function () {
  'use strict';
  var B = window.BISOU || {}, R = B.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem('bisou_' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem('bisou_' + k, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } }
  };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/œ/g, 'oe'); };
  function money(cents) {
    var v = (cents / 100).toFixed(2), whole = String(Math.round(cents / 100));
    return (B.moneyFormat || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return whole;
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return v;
    });
  }
  function sectionHTML(text, selector) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return selector ? doc.querySelector(selector) : doc.body;
  }
  function withParam(url, param) { return url + (url.indexOf('?') > -1 ? '&' : '?') + param; }

  /* ---------- Messages ---------- */
  var toastTimer;
  function toast(msg) { var t = $('#toast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2400); }

  /* ---------- Fenêtres : panier et aperçus ---------- */
  var overlay = $('#overlay'), drawer = $('#cartDrawer'), modal = $('#quick'), lastFocus = null;
  function isOpen() { return overlay && !overlay.hidden; }
  function openCart() { if (!drawer) return; if (!isOpen()) lastFocus = document.activeElement; closeModal(); overlay.hidden = false; drawer.hidden = false; var c = $('[data-close]', drawer); if (c) c.focus(); }
  function closeModal() { if (modal) { modal.hidden = true; modal.innerHTML = ''; } }
  function closeAll() { if (!isOpen()) return; overlay.hidden = true; if (drawer) drawer.hidden = true; closeModal(); if (lastFocus && document.contains(lastFocus)) lastFocus.focus(); }
  function openModal(inner, cls, label) {
    if (!modal) return;
    if (!isOpen()) lastFocus = document.activeElement;
    if (drawer) drawer.hidden = true;
    modal.setAttribute('aria-label', label || 'Fenêtre');
    modal.innerHTML = '<div class="modal__box ' + (cls || '') + '"><button type="button" class="icon-btn modal__close" data-close aria-label="Fermer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' + inner + '</div>';
    modal.hidden = false; overlay.hidden = false; $('.modal__close', modal).focus(); paintFavs();
  }

  /* ---------- Panier (API Ajax de Shopify + rendu de la section « cart-drawer ») ---------- */
  function cartPost(url, body) {
    body.sections = 'cart-drawer';
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); });
  }
  function refreshCart(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    if (html) {
      var fresh = sectionHTML(html, '#cartContents'), current = $('#cartContents');
      if (fresh && current) { current.innerHTML = fresh.innerHTML; current.dataset.count = fresh.dataset.count; }
    }
    var count = $('#cartContents') ? $('#cartContents').dataset.count : null, badge = $('#cartCount'), btn = $('#cartBtn');
    if (badge && count !== null) badge.textContent = count;
    if (btn) { btn.classList.remove('bump'); void btn.offsetWidth; btn.classList.add('bump'); }
    renderLater();
  }
  function cartError(err) { toast((err && (err.description || err.message)) || 'Une erreur est survenue, réessaie.'); }
  function addItems(items, quiet) {
    return cartPost(R.cartAdd, { items: items }).then(function (data) {
      if (B.template === 'cart') { location.reload(); return; }
      refreshCart(data); if (quiet) toast('Ajouté au panier'); else openCart();
    }).catch(cartError);
  }
  function changeLine(line, quantity) {
    return cartPost(R.cartChange, { line: line, quantity: quantity }).then(function (data) {
      if (B.template === 'cart') { location.reload(); return; }
      refreshCart(data);
    }).catch(cartError);
  }
  var noteTimer;
  function cartUpdate(body, done) {
    return cartPost(R.cartUpdate, body).then(function (data) {
      if (done && done(data) === false) return;
      if (B.template === 'cart') { location.reload(); return; }
      refreshCart(data);
    }).catch(cartError);
  }
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(R.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: value }) }).catch(function () {});
    }, 500);
  }
  function applyPromo(code) {
    code = String(code || '').trim(); if (!code) return;
    cartUpdate({ discount: code }, function (data) {
      var list = data.discount_codes;
      if (!list) { location.href = R.root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart); return false; }
      var ok = list.some(function (d) { return norm(d.code) === norm(code) && d.applicable; });
      toast(ok ? 'Code ' + code.toUpperCase() + ' appliqué' : 'Ce code n\'est pas valide');
    });
  }
  /* Articles mis de côté : gardés dans le navigateur, affichés sous le panier. */
  var later = store.get('later', []);
  function renderLater() {
    var html = later.length ? '<div class="upsell upsell--plain"><strong>Mis de côté pour plus tard</strong>' + later.map(function (l, i) {
      return '<div class="mini"><a href="' + esc(l.url) + '">' + (l.image ? '<img src="' + esc(l.image) + '" alt="" width="64" height="64">' : '') + '</a><div><a class="mini__title" href="' + esc(l.url) + '">' + esc(l.title) + '</a>' +
        '<div class="line__opt">' + (l.variant ? esc(l.variant) + ' · ' : '') + money(l.price) + '</div><button type="button" class="remove" data-later-remove="' + i + '">Retirer</button></div>' +
        '<button type="button" class="btn" data-later-restore="' + i + '">Remettre</button></div>';
    }).join('') + '</div>' : '';
    $$('[data-later-list]').forEach(function (el) { el.innerHTML = html; });
  }

  /* ---------- Favoris et produits vus (gardés dans le navigateur) ---------- */
  var favs = store.get('favs', []), seen = store.get('seen', []);
  function paintFavs() {
    $$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', favs.indexOf(b.dataset.fav) > -1); });
    var c = $('#favCount'); if (c) { c.textContent = favs.length; c.hidden = !favs.length; }
  }
  function loadCards(handles, grid) {
    return Promise.all(handles.map(function (h) {
      return fetch(withParam(R.root + 'products/' + encodeURIComponent(h), 'section_id=product-card')).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (pages) {
      var n = 0;
      pages.forEach(function (text) { var card = text && sectionHTML(text, '.card'); if (card) { grid.appendChild(card); n++; } });
      paintFavs(); return n;
    });
  }
  function initWishlist() {
    var root = $('[data-wishlist]'); if (!root) return;
    var grid = $('.grid', root), count = $('[data-wishlist-count]', root), empty = $('[data-wishlist-empty]', root), all = $('[data-wishlist-add-all]', root);
    grid.innerHTML = '';
    loadCards(favs, grid).then(function (n) {
      count.textContent = n + ' produit' + (n > 1 ? 's' : '');
      empty.hidden = n > 0; all.hidden = !$('[data-add]', grid);
    });
  }
  function initRecent() {
    var handle = ($('[data-product-handle]') || { dataset: {} }).dataset.productHandle;
    $$('[data-recent]').forEach(function (sec) {
      var list = seen.filter(function (h) { return h !== sec.dataset.exclude; }).slice(0, 4);
      if (list.length) loadCards(list, $('.grid', sec)).then(function (n) { sec.hidden = !n; });
    });
    if (handle) { seen = [handle].concat(seen.filter(function (h) { return h !== handle; })).slice(0, 8); store.set('seen', seen); }
  }
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (sec) {
      fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (text) {
        var fresh = sectionHTML(text, '[data-recommendations]'); if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; paintFavs(); }
      }).catch(function () {});
    });
  }

  /* ---------- Fiche produit : variantes ---------- */
  function updateVariant(root) {
    var data = $('[data-variants]', root); if (!data) return;
    var variants = JSON.parse(data.textContent), chosen = [];
    $$('input[data-option]:checked', root).forEach(function (i) { chosen[+i.dataset.option - 1] = i.value; });
    var variant = variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
    var btn = $('[data-submit]', root), price = $('[data-price]', root);
    updateStockAlert(root, variant);
    if (!variant) { btn.disabled = true; btn.textContent = 'Indisponible'; return; }
    $('[data-variant-id]', root).value = variant.id;
    btn.disabled = !variant.available; btn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
    price.innerHTML = money(variant.price) + (variant.compare_at_price > variant.price ? ' <s class="price__was">' + money(variant.compare_at_price) + '</s>' : '');
    var onPage = root.closest('[data-product-handle]');
    if (onPage) {
      var sticky = $('#stickyBuy .price'); if (sticky) sticky.textContent = money(variant.price);
      if (variant.featured_image) setMainImage(variant.featured_image.src);
      try { history.replaceState(null, '', withParam(location.pathname, 'variant=' + variant.id)); } catch (e) { /* adresse non modifiable */ }
    }
  }
  function updateStockAlert(root, variant) {
    var alert = $('[data-stock-alert]', root), data = $('[data-low-stock]', root);
    if (!alert || !data) return;
    var qty = 0;
    try { qty = variant ? +JSON.parse(data.textContent)[variant.id] || 0 : 0; } catch (e) { qty = 0; }
    alert.hidden = !(qty > 0 && variant.available);
    if (qty > 0) $('[data-stock-text]', alert).innerHTML = 'Plus que ' + qty + (qty === 1 ? ' pièce' : ' pièces') + ' en stock, fais vite&nbsp;!';
  }
  function setMainImage(src) { var img = $('[data-zoom] img'); if (img && src) { img.removeAttribute('srcset'); img.src = src; } }

  /* ---------- Recherche : suggestions ---------- */
  var searchTimer, searches = store.get('searches', []);
  function hideSuggest() { var b = $('#suggest'); if (b) b.hidden = true; }
  function showSuggest(q) {
    var box = $('#suggest'), form = $('#searchForm'); if (!box || !form) return;
    q = q.trim();
    if (q.length < 2) {
      var chip = function (t) { return '<a class="chip chip--sm" href="' + withParam(R.search, 'type=product&q=' + encodeURIComponent(t)) + '">' + esc(t) + '</a>'; };
      var trends = (form.dataset.trends || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      box.innerHTML = (searches.length ? '<p class="suggest__label">Recherches récentes</p><div class="chips">' + searches.map(chip).join('') + '</div>' : '') +
        (trends.length ? '<p class="suggest__label">Tendances</p><div class="chips">' + trends.map(chip).join('') + '</div>' : '');
      box.hidden = !box.innerHTML; return;
    }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      fetch(R.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (text) { var fresh = sectionHTML(text, '#shopify-section-predictive-search'); if (fresh) { box.innerHTML = fresh.innerHTML; box.hidden = false; } })
        .catch(function () {});
    }, 250);
  }

  /* ---------- Liste filtrable (collections et recherche) ---------- */
  var SWATCH = { 'Argenté': '#C9CDD3', 'Doré': '#D9B45A', 'Or rose': '#E3B0A0', 'Vert sapin': '#1F6B57', 'Rose': '#F4A6C0', 'Rose poudré': '#F6D3DC', 'Bleu': '#3F7FD9', 'Bleu ciel': '#A9D3F2', 'Noir': '#1E1A1C', 'Blanc': '#FFFFFF', 'Chocolat': '#5A3626', 'Écaille': '#8A5A2B', 'Gris fumé': '#8C8C94', 'Rouge': '#D22B2B', 'Transparent': '#EDF1F4', 'Orange': '#F08A24', 'Gris transparent': '#C8CCD1' };
  var CLOSE = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function setDensity(d) {
    $$('[data-density-target]').forEach(function (g) { g.className = 'grid grid--' + d; });
    $$('[data-density]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.density === d); });
  }
  function initListing() {
    setDensity(store.get('density', 'grid'));
    var root = $('[data-listing]'); if (!root) return;
    var grid = $('[data-grid]', root), facets = $('#facets', root), showCats = root.dataset.showCategories === 'true', PER = +root.dataset.perPage || 12;
    var items = $$('[data-card]', grid).map(function (el) {
      return { el: el, id: +el.dataset.id, pos: +el.dataset.pos || 0, price: +el.dataset.price / 100, type: el.dataset.type, colors: el.dataset.colors ? el.dataset.colors.split('|') : [], badge: el.dataset.badge, title: el.dataset.title };
    }).sort(function (a, b) { return (a.pos - b.pos) || (a.id - b.id); });
    var PRESETS = [['Tous les prix', null, null], ['Moins de 10 €', null, 9.99], ['10 à 20 €', 10, 19.99], ['20 à 40 €', 20, 39.99], ['Plus de 40 €', 40, null]];
    var BADGES = ['Nouveau', 'Coup de cœur', 'Tendance'];
    var PMAX = Math.max(5, Math.ceil(Math.max.apply(null, items.map(function (p) { return p.price; }).concat([0])) / 5) * 5);
    var types = [], colors = [];
    items.forEach(function (p) { if (types.indexOf(p.type) < 0) types.push(p.type); p.colors.forEach(function (c) { if (colors.indexOf(c) < 0) colors.push(c); }); });
    var qs = new URLSearchParams(location.search), num = function (v) { var x = parseFloat(v); return isNaN(x) ? null : x; }, split = function (v) { return v ? v.split(',').filter(Boolean) : []; };
    var SORTS = ['featured', 'new', 'price-asc', 'price-desc', 'title', 'title-desc'];
    var sort = SORTS.indexOf(qs.get('sort')) > -1 ? qs.get('sort') : 'featured';
    var price = { min: num(qs.get('min')), max: num(qs.get('max')) };
    var filt = { cats: showCats ? split(qs.get('cat')).filter(function (c) { return types.indexOf(c) > -1; }) : [], colors: split(qs.get('couleur')), badges: split(qs.get('tag')).filter(function (b) { return BADGES.indexOf(b) > -1; }) };
    var page = 1;
    $('#sort', root).value = sort;

    function matches(p, skip) {
      if (skip !== 'price' && ((price.min !== null && p.price < price.min) || (price.max !== null && p.price > price.max))) return false;
      if (skip !== 'cats' && filt.cats.length && filt.cats.indexOf(p.type) < 0) return false;
      if (skip !== 'colors' && filt.colors.length && !p.colors.some(function (c) { return filt.colors.indexOf(c) > -1; })) return false;
      if (skip !== 'badges' && filt.badges.length && filt.badges.indexOf(p.badge) < 0) return false;
      return true;
    }
    function sorted(list) {
      var l = list.slice();
      if (sort === 'price-asc') l.sort(function (a, b) { return a.price - b.price; });
      if (sort === 'price-desc') l.sort(function (a, b) { return b.price - a.price; });
      if (sort === 'title') l.sort(function (a, b) { return a.title.localeCompare(b.title, 'fr'); });
      if (sort === 'title-desc') l.sort(function (a, b) { return b.title.localeCompare(a.title, 'fr'); });
      if (sort === 'new') l.sort(function (a, b) { return (b.badge === 'Nouveau') - (a.badge === 'Nouveau'); });
      return l;
    }
    var euro = function (n) { return n.toFixed(2).replace('.', ',') + ' €'; };
    var priceOn = function () { return price.min !== null || price.max !== null; };
    var fid = function (k, v) { return 'f_' + k + '_' + norm(v).replace(/[^a-z0-9]/g, ''); };
    function check(k, v, n) {
      var on = filt[k].indexOf(v) > -1;
      return '<label class="check" for="' + fid(k, v) + '"><input type="checkbox" id="' + fid(k, v) + '" data-f="' + k + '" value="' + esc(v) + '"' + (on ? ' checked' : '') + (n || on ? '' : ' disabled') + '><span>' + esc(v) + '</span><small>' + n + '</small></label>';
    }
    function drawFacets() {
      var count = function (skip, test) { return items.filter(function (p) { return matches(p, skip) && test(p); }).length; };
      var v = function (n) { return n === null ? '' : String(n).replace('.', ','); };
      var lo = price.min === null ? 0 : Math.floor(price.min), hi = price.max === null ? PMAX : Math.min(PMAX, Math.ceil(price.max));
      var h = '<div class="facets__head"><strong>Filtres</strong><button type="button" class="icon-btn only-mobile" data-facets-close aria-label="Fermer les filtres"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      if (showCats && types.length > 1) h += '<fieldset class="facet"><legend>Catégorie</legend>' + types.map(function (t) { return check('cats', t, count('cats', function (p) { return p.type === t; })); }).join('') + '</fieldset>';
      h += '<fieldset class="facet"><legend>Prix</legend><div class="range"><div class="range__track"><span id="rangeFill"></span></div>' +
        '<input type="range" id="rmin" aria-label="Prix minimum" min="0" max="' + PMAX + '" step="1" value="' + lo + '"><input type="range" id="rmax" aria-label="Prix maximum" min="0" max="' + PMAX + '" step="1" value="' + hi + '"></div>' +
        '<div class="range__vals"><span id="rminV"></span><span id="rmaxV"></span></div><div class="facet__chips">' + PRESETS.slice(1).map(function (x, i) {
          return '<button type="button" class="chip chip--sm" id="f_preset_' + (i + 1) + '" data-preset="' + (i + 1) + '" aria-pressed="' + (price.min === x[1] && price.max === x[2]) + '">' + x[0] + '</button>';
        }).join('') + '</div><form class="facet__inputs" data-price-form><label for="pmin">De</label><input class="num" id="pmin" inputmode="decimal" placeholder="Min" value="' + v(price.min) + '">' +
        '<label for="pmax">à</label><input class="num" id="pmax" inputmode="decimal" placeholder="Max" value="' + v(price.max) + '"><span>€</span><button type="submit" class="btn btn--sm">OK</button></form></fieldset>';
      if (colors.length) h += '<fieldset class="facet"><legend>Couleur</legend><div class="facet__chips">' + colors.map(function (c) {
        return '<button type="button" class="chip chip--sm" id="' + fid('colors', c) + '" data-color="' + esc(c) + '" aria-pressed="' + (filt.colors.indexOf(c) > -1) + '"><span class="dot" style="background:' + (SWATCH[c] || '#ccc') + '"></span>' + esc(c) + '</button>';
      }).join('') + '</div></fieldset>';
      h += '<fieldset class="facet"><legend>Sélection</legend>' + BADGES.map(function (b) { return check('badges', b, count('badges', function (p) { return p.badge === b; })); }).join('') + '</fieldset>';
      facets.innerHTML = h + '<button type="button" class="btn btn--primary btn--block only-mobile" data-facets-close>Voir les résultats</button>';
      paintRange();
      var n = filt.cats.length + filt.colors.length + filt.badges.length + (priceOn() ? 1 : 0);
      $('[data-filter-label]', root).textContent = 'Filtrer' + (n ? ' (' + n + ')' : '');
    }
    function paintRange() {
      var a = $('#rmin', root), b = $('#rmax', root); if (!a || !b) return null;
      var lo = Math.min(+a.value, +b.value), hi = Math.max(+a.value, +b.value);
      $('#rminV', root).textContent = euro(lo); $('#rmaxV', root).textContent = hi >= PMAX ? euro(PMAX) + ' et plus' : euro(hi);
      var f = $('#rangeFill', root); f.style.left = (lo / PMAX * 100) + '%'; f.style.width = ((hi - lo) / PMAX * 100) + '%';
      return { lo: lo, hi: hi };
    }
    function drawResults() {
      var list = sorted(items.filter(function (p) { return matches(p); })), shown = list.slice(0, page * PER), chips = [];
      items.forEach(function (p) { p.el.hidden = true; });
      shown.forEach(function (p) { p.el.hidden = false; grid.appendChild(p.el); });
      filt.cats.forEach(function (c) { chips.push(['cats', c, c]); });
      filt.colors.forEach(function (c) { chips.push(['colors', c, c]); });
      filt.badges.forEach(function (c) { chips.push(['badges', c, c]); });
      if (priceOn()) chips.push(['price', '', price.min !== null && price.max !== null ? euro(price.min) + ' à ' + euro(price.max) : (price.max !== null ? 'Jusqu\'à ' + euro(price.max) : 'Dès ' + euro(price.min))]);
      $('[data-count]', root).textContent = list.length + ' produit' + (list.length > 1 ? 's' : '') + (list.length !== items.length ? ' sur ' + items.length : '');
      var act = $('[data-active]', root);
      act.hidden = !chips.length;
      act.innerHTML = chips.map(function (c) { return '<button type="button" class="chip chip--sm chip--x" data-chip="' + c[0] + '" data-value="' + esc(c[1]) + '" aria-label="Retirer le filtre ' + esc(c[2]) + '">' + esc(c[2]) + CLOSE + '</button>'; }).join('') + '<button type="button" class="remove" data-clear>Tout effacer</button>';
      $('[data-more]', root).hidden = list.length <= shown.length;
      $('[data-more-label]', root).textContent = shown.length + ' produits affichés sur ' + list.length;
      $('[data-empty]', root).hidden = list.length > 0;
      grid.hidden = !list.length;
      paintFavs();
    }
    function syncURL() {
      var p = new URLSearchParams();
      ['q', 'type'].forEach(function (k) { if (qs.get(k)) p.set(k, qs.get(k)); });
      if (sort !== 'featured') p.set('sort', sort);
      if (price.min !== null) p.set('min', price.min);
      if (price.max !== null) p.set('max', price.max);
      if (filt.cats.length) p.set('cat', filt.cats.join(','));
      if (filt.colors.length) p.set('couleur', filt.colors.join(','));
      if (filt.badges.length) p.set('tag', filt.badges.join(','));
      var s = p.toString();
      try { history.replaceState(null, '', location.pathname + (s ? '?' + s : '')); } catch (e) { /* adresse non modifiable */ }
    }
    function changed() {
      var id = document.activeElement && document.activeElement.id;
      page = 1; syncURL(); drawFacets(); drawResults();
      if (id) { var el = document.getElementById(id); if (el) el.focus(); }
    }
    function toggle(list, v) { var i = list.indexOf(v); if (i > -1) list.splice(i, 1); else list.push(v); }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.id === 'sort') { sort = t.value; page = 1; syncURL(); drawResults(); }
      else if (t.dataset.f) { toggle(filt[t.dataset.f], t.value); changed(); }
      else if (t.id === 'rmin' || t.id === 'rmax') changed();
    });
    root.addEventListener('input', function (e) {
      if (e.target.id !== 'rmin' && e.target.id !== 'rmax') return;
      var v = paintRange(); price = { min: v.lo > 0 ? v.lo : null, max: v.hi < PMAX ? v.hi : null }; page = 1; drawResults();
    });
    root.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-price-form]')) return;
      e.preventDefault();
      var read = function (id) { var x = parseFloat($(id, root).value.replace(',', '.')); return isNaN(x) || x < 0 ? null : x; };
      var a = read('#pmin'), b = read('#pmax'); if (a !== null && b !== null && a > b) { var tmp = a; a = b; b = tmp; }
      price = { min: a, max: b }; changed();
    });
    root.addEventListener('click', function (e) {
      var t = e.target, el;
      if ((el = t.closest('[data-preset]'))) { var x = PRESETS[+el.dataset.preset], same = price.min === x[1] && price.max === x[2]; price = same ? { min: null, max: null } : { min: x[1], max: x[2] }; changed(); }
      else if ((el = t.closest('[data-color]'))) { toggle(filt.colors, el.dataset.color); changed(); }
      else if ((el = t.closest('[data-chip]'))) { if (el.dataset.chip === 'price') price = { min: null, max: null }; else toggle(filt[el.dataset.chip], el.dataset.value); changed(); }
      else if (t.closest('[data-clear]')) { price = { min: null, max: null }; filt = { cats: [], colors: [], badges: [] }; changed(); }
      else if (t.closest('[data-more-button]')) { page++; drawResults(); }
    });
    drawFacets(); drawResults();
  }

  /* ---------- Mode sombre et ambiance ---------- */
  function paintTheme() {
    var html = document.documentElement, mb = $('#modeBtn'), dark = html.dataset.mode === 'dark';
    if (mb) { mb.setAttribute('aria-pressed', dark); mb.setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode sombre'); }
    $$('[data-theme-choice]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.themeChoice === html.dataset.theme); });
  }

  /* ---------- Quiz ---------- */
  var QUIZ = [
    ['Tu cherches plutôt…', [['boucle,collier,bague,bracelet', 'Un bijou'], ['cheveux', 'Un accessoire cheveux'], ['sac', 'Un sac'], ['', 'Surprends-moi']]],
    ['Ton style, c\'est…', [['dore', 'Doré et lumineux'], ['argent', 'Argenté et minimaliste'], ['couleur', 'Coloré et fun'], ['', 'Un peu de tout']]],
    ['Ton budget ?', [['0-10', 'Moins de 10 €'], ['10-20', '10 à 20 €'], ['20-9999', 'Plus de 20 €'], ['', 'Peu importe']]]
  ];
  function initQuiz() {
    var root = $('[data-quiz]'), data = $('#quizProducts'); if (!root || !data) return;
    var products = []; try { products = JSON.parse(data.textContent); } catch (e) { products = []; }
    var step = 0, answers = [];
    function picks() {
      var types = answers[0] ? answers[0].split(',') : [], range = answers[2] ? answers[2].split('-').map(Number) : null;
      var styleOk = function (p) {
        var t = norm(p.text + ' ' + p.colors);
        if (answers[1] === 'dore') return t.indexOf('dore') > -1;
        if (answers[1] === 'argent') return t.indexOf('argent') > -1;
        return p.colors.split(' ').length > 2 || /color|pop|rose|bonbon/.test(t);
      };
      return products.filter(function (p) { var ty = norm(p.type); return !types.length || types.some(function (k) { return ty.indexOf(k) > -1; }); })
        .map(function (p) { var euros = p.price / 100; return [(answers[1] && styleOk(p) ? 2 : 0) + (range && euros >= range[0] && euros < range[1] ? 2 : 0) + (p.tagged ? 1 : 0), p]; })
        .sort(function (a, b) { return b[0] - a[0]; }).slice(0, 4).map(function (x) { return x[1].handle; });
    }
    function draw() {
      if (step >= QUIZ.length) {
        root.innerHTML = '<h1 class="page-title">Ta sélection sur mesure</h1><p class="lead">D\'après tes réponses, voici ce qui devrait te plaire.</p><div class="grid"></div>' +
          '<div class="hero__cta" style="margin-top:28px"><button type="button" class="btn" data-quiz-reset>Recommencer</button><a class="btn btn--primary" href="' + R.root + 'collections/all">Voir toute la boutique</a></div>';
        loadCards(picks(), $('.grid', root)); return;
      }
      var q = QUIZ[step];
      root.innerHTML = '<div class="quiz"><span class="pill">Question ' + (step + 1) + ' sur ' + QUIZ.length + '</span><h1 class="page-title">' + esc(q[0]) + '</h1>' +
        '<div class="progress" aria-hidden="true"><span style="width:' + Math.round((step + 1) / QUIZ.length * 100) + '%"></span></div><div class="quiz__opts">' +
        q[1].map(function (o, i) { return '<button type="button" class="quiz__opt" data-quiz-answer="' + o[0] + '"><b>' + 'ABCD'.charAt(i) + '</b>' + esc(o[1]) + '</button>'; }).join('') + '</div>' +
        (step ? '<button type="button" class="remove" data-quiz-back>Question précédente</button>' : '') + '</div>';
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-quiz-answer]');
      if (a) { answers[step] = a.dataset.quizAnswer; step++; draw(); }
      else if (e.target.closest('[data-quiz-back]')) { step = Math.max(0, step - 1); draw(); }
      else if (e.target.closest('[data-quiz-reset]')) { step = 0; answers = []; draw(); }
    });
    draw();
  }

  /* ---------- Événements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t.closest('#searchForm')) hideSuggest();
    if (t === document.body) { document.body.classList.remove('facets-open'); return; }
    if ((el = t.closest('#cartBtn'))) { if (drawer && B.template !== 'cart') { e.preventDefault(); openCart(); } return; }
    if (t.closest('[data-close]') || t === overlay) { closeAll(); return; }
    if ((el = t.closest('[data-add]'))) { addItems([{ id: +el.dataset.add, quantity: 1 }], el.hasAttribute('data-quiet')); return; }
    if ((el = t.closest('[data-add-many]'))) { addItems(el.dataset.addMany.split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; })); return; }
    if ((el = t.closest('[data-wishlist-add-all]'))) { addItems($$('[data-wishlist] [data-add]').map(function (b) { return { id: +b.dataset.add, quantity: 1 }; })); return; }
    if ((el = t.closest('[data-quick]'))) {
      fetch(withParam(el.dataset.quick, 'section_id=quick-view')).then(function (r) { return r.text(); }).then(function (text) {
        var fresh = sectionHTML(text, '#shopify-section-quick-view'); if (fresh) openModal(fresh.innerHTML, '', 'Aperçu rapide du produit');
      }).catch(function () { location.href = el.dataset.quick; });
      return;
    }
    if ((el = t.closest('[data-later]'))) {
      later.push({ id: +el.dataset.variant, title: el.dataset.title, variant: el.dataset.variantTitle, price: +el.dataset.price, url: el.dataset.url, image: el.dataset.image });
      store.set('later', later); toast('Mis de côté pour plus tard'); changeLine(+el.dataset.cartLine, 0); return;
    }
    if ((el = t.closest('[data-later-restore]'))) { var back = later.splice(+el.dataset.laterRestore, 1)[0]; store.set('later', later); if (back) addItems([{ id: back.id, quantity: 1 }], true); renderLater(); return; }
    if ((el = t.closest('[data-later-remove]'))) { later.splice(+el.dataset.laterRemove, 1); store.set('later', later); renderLater(); return; }
    if (t.closest('[data-promo-remove]')) { cartUpdate({ discount: '' }); return; }
    if ((el = t.closest('[data-cart-qty]'))) { changeLine(+el.dataset.cartLine, +el.dataset.cartQty); return; }
    if ((el = t.closest('[data-fav]'))) {
      var h = el.dataset.fav, i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      store.set('favs', favs); paintFavs(); toast(i > -1 ? 'Retiré des favoris' : 'Ajouté aux favoris');
      if (i > -1 && el.closest('[data-wishlist]')) initWishlist();
      return;
    }
    if ((el = t.closest('[data-step]'))) { var inp = $('input', el.closest('.qty')); inp.value = Math.max(1, Math.min(99, (parseInt(inp.value, 10) || 1) + (+el.dataset.step))); return; }
    if ((el = t.closest('[data-zoom]'))) { var img = $('img', el); openModal('<img class="lightbox" src="' + esc(img.currentSrc || img.src) + '" alt="' + esc(img.alt) + '">', 'modal__box--photo', 'Photo agrandie'); return; }
    if ((el = t.closest('[data-thumb]'))) { setMainImage(el.dataset.thumb); $$('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === el); }); return; }
    if (t.closest('[data-guide]')) { var tpl = $('#sizeGuide'); if (tpl) openModal(tpl.innerHTML, 'modal__box--text', 'Guide des tailles'); return; }
    if ((el = t.closest('[data-share]'))) {
      var url = location.href, copied = function () { toast('Lien copié'); }, failed = function () { toast('Copie impossible : copie l\'adresse de la page'); };
      if (navigator.share) navigator.share({ title: el.dataset.title || document.title, url: url }).catch(function () {});
      else if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(copied, failed);
      else failed();
      return;
    }
    if (t.closest('#modeBtn')) { var html = document.documentElement; html.dataset.mode = html.dataset.mode === 'dark' ? 'light' : 'dark'; store.set('mode', html.dataset.mode); paintTheme(); return; }
    if ((el = t.closest('[data-theme-choice]'))) { document.documentElement.dataset.theme = el.dataset.themeChoice; store.set('theme', el.dataset.themeChoice); paintTheme(); return; }
    if ((el = t.closest('[data-density]'))) { store.set('density', el.dataset.density); setDensity(el.dataset.density); return; }
    if (t.closest('[data-facets-open]')) { document.body.classList.add('facets-open'); return; }
    if (t.closest('[data-facets-close]')) { document.body.classList.remove('facets-open'); return; }
    if (t.closest('[data-welcome-close]')) { store.set('welcome', true); var w = $('#welcome'); if (w) w.hidden = true; return; }
    if (t.closest('[data-welcome-apply]')) { store.set('welcome', true); return; }
    if (t.closest('#menuBtn')) { var open = $('#nav').classList.toggle('is-open'); $('#menuBtn').setAttribute('aria-expanded', open); return; }
    if (t.closest('#toTop')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('input[data-option]')) { updateVariant(t.closest('[data-product-form]')); return; }
    if (t.matches('[data-cart-input]')) { changeLine(+t.dataset.cartLine, Math.max(0, parseInt(t.value, 10) || 0)); return; }
    if (t.matches('[data-cart-gift]')) cartUpdate({ attributes: { Cadeau: t.checked ? 'Oui' : '' } });
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-cart-note]')) saveNote(t.value);
    if (t.id === 'searchInput') showSuggest(t.value);
  });
  document.addEventListener('focusin', function (e) { if (e.target.id === 'searchInput') showSuggest(e.target.value); });
  document.addEventListener('submit', function (e) {
    var f = e.target, root = f.closest('[data-product-form]');
    if (root) {
      e.preventDefault();
      addItems([{ id: +$('[data-variant-id]', root).value, quantity: Math.max(1, parseInt(f.elements.quantity.value, 10) || 1) }]);
    } else if (f.matches('[data-promo]')) { e.preventDefault(); applyPromo(f.elements.code.value); }
    else if (f.id === 'searchForm') {
      var q = $('#searchInput').value.trim();
      if (q) { searches = [q].concat(searches.filter(function (x) { return norm(x) !== norm(q); })).slice(0, 5); store.set('searches', searches); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hideSuggest(); closeAll(); document.body.classList.remove('facets-open'); } });
  document.addEventListener('mousemove', function (e) {
    var z = e.target.closest && e.target.closest('.zoomable'); if (!z) return;
    var b = z.getBoundingClientRect(); $('img', z).style.transformOrigin = ((e.clientX - b.left) / b.width * 100) + '% ' + ((e.clientY - b.top) / b.height * 100) + '%';
  });
  window.addEventListener('scroll', function () { var b = $('#toTop'); if (b) b.hidden = window.scrollY < 700; }, { passive: true });

  /* ---------- Démarrage ---------- */
  function init() {
    overlay = $('#overlay'); drawer = $('#cartDrawer'); modal = $('#quick');
    paintTheme(); paintFavs(); renderLater(); initListing(); initWishlist(); initRecent(); initRecommendations(); initQuiz();
    var first = $('[data-thumb]'); if (first) first.setAttribute('aria-current', 'true');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
